import { Table, TableColumnType } from 'antd'
import dayjs from 'dayjs'
import { Contracts } from 'gadjet-v2-types/dist/model'
import { ContractExtendStatus } from 'gadjet-v2-types/dist/type'
import { contractExtendStatus } from 'gadjet-v2-types/dist/type/label'

import TableColumnItem from '@components/molecules/TableColumn/Item'
import TypeTag from '@components/molecules/TypeTag'

type Props = {
  contracts: Contracts[]
}

export default function EndContractTable({ contracts }: Props): JSX.Element {
  const columns: TableColumnType<Contracts>[] = [
    { key: 'tenant', dataIndex: 'tenant', title: '입주사', render: (_, { tenant }) => tenant.name },
    {
      key: 'spaces',
      dataIndex: 'spaces',
      title: '공간',
      render: (_, { contractSpaces }) => {
        if (!contractSpaces) return '-'
        return contractSpaces.map(({ spaceId, name }) => <div key={spaceId}>{name}</div>)
      },
    },
    {
      key: 'contractId',
      dataIndex: 'contractId',
      title: '계약기간',
      render: (_, { startDate, suspendDate }) => (
        <>
          <TableColumnItem label="시작" value={dayjs(startDate).format('YYYY년 MM월 DD일')} />
          <TableColumnItem label="종료" value={dayjs(suspendDate).format('YYYY년 MM월 DD일')} />
        </>
      ),
    },
    {
      key: 'extendStatus',
      dataIndex: 'extendStatus',
      title: '연장상태',
      align: 'center',
      render: (_, { extendStatus }) => (
        <TypeTag<ContractExtendStatus>
          label={contractExtendStatus[extendStatus]}
          value={extendStatus}
          switchCase={{
            values: [['none'], ['asked'], ['approval'], ['refusal']],
            types: ['default', 'ongoing', 'success', 'fail'],
          }}
        />
      ),
    },
  ]
  return <Table rowKey={({ contractId }) => `${contractId}`} dataSource={contracts} columns={columns} />
}
